const greenPropertyIndex = r => require.ensure([], () => r(require('@/page/greenProperty/greenPropertyIndex')), 'greenPropertyIndex');
const greenPropertyView = r => require.ensure([], () => r(require('@/page/greenProperty/greenPropertyView')), 'greenPropertyView');
const greenPropertyStatistical = r => require.ensure([], () => r(require('@/page/greenProperty/greenPropertyStatistical')), 'greenPropertyStatistical');
const greenParking = r => require.ensure([], () => r(require('@/page/greenProperty/greenParking')), 'greenParking');
const greenDetail= r => require.ensure([], () => r(require('@/page/greenProperty/green/greenDetail')), 'greenDetail');


const greenPropertyRouter = {
    path: '',
    name: '绿色物业',
    component: greenPropertyView,
    meta: {
      right: [],
      isShowMenu: true,
      icon: 'organMge',
  },
    children: [
        {
            path: '/greenPropertyIndex',
            component: greenPropertyIndex,
            name: '绿色物业录入',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive: true,
            },
        },
        {
          path: '/greenDetail',
          component: greenDetail,
          name: '绿色物业详情',
          meta: {
            right: [],
            isShowMenu: true,
            keepAlive:false,
          },
        },
        {
          path: '/greenPropertyStatistical',
          component: greenPropertyStatistical,
          name: '绿色物业统计',
          meta: {
              right: [],
          },
      },
      {
        path: '/greenParking',
        component: greenParking,
        name: '绿色物业项目统计',
        meta: {
            right: [],
        },
    },

    ]
};
export default greenPropertyRouter;